import './dashboard.css';
import CardDashboard from "../../components/dashboardComponents/cardDashboard/cardDashboard";
import DashboardChart from "../../components/dashboardComponents/dashboardChart/DashboardChart";
import OverallSummary from "../../components/overallSummary/overallSummary";
import FleetComparison from "../../components/dashboardComponents/fleetComparison/fleetComparison";
import DashCompareChart from "../../components/dashboardComponents/dashCompareChart/dashCompareChart";
import RadioButton from "../../shared/radioButton/radioButton";
import CalendarType from "../../shared/calendarType/calendarType";
import DateRangePicker from "../../shared/dateRangePicker/dateRangePicker";
import DriverCards from "../../components/driverCards/driverCards";
import {useState} from "react";
import Placeholder from "../../shared/placeholder/placeholder";
import VideoSec from "../../components/videoSec/videoSec";

const Dashboard = () => {
    const [driverType, setDriverType] = useState('worst');

    const [showVideoPlayer, setShowVideoPlayer] = useState(false);
    const handleShowVideoPlayer = (val, videoData, alertData) => {
        setShowVideoPlayer(val);
        window.scroll({
            top: 0,
            behavior: 'smooth'
        });
    }

    return(
        <div className={'content-section page-fade-in'}>
            <div className=" round-corner-8 padding-tb-20 flex hr-right border-bottom margin-b-30">
                <DateRangePicker selectRange={true} classes={'date width-300 item-height-40'}/>
                <CalendarType/>
            </div>


            <div className="">
                {/*<GoogleMaps/>*/}
            </div>

            {/*..... card dashboard .....*/}
            <div className="margin-b-50 dashboard-card-box"><CardDashboard/></div>

            {/*........ chart .......*/}
            <div className="margin-b-50">
                <div className="sf-medium highlight-color font-18 margin-b-15">Safety Performance</div>
                <div className="dashboard-chart"><DashboardChart/></div>
            </div>

            {/*........ drivers cards .....*/}
            <div className="margin-b-50">
                <div className="sf-medium flex hr-space-between section-title margin-b-20">
                    <div className="flex highlight-color">
                        <div className={`cursor-pointer transition-300 ${driverType !== 'worst' ? 'light-color' : ''}`}
                             onClick={e => setDriverType('worst')}>Worst Drivers</div>
                        <div className={`cursor-pointer transition-300 ${driverType !== 'best' ? 'light-color' : ''}`}
                             onClick={e => setDriverType('best')}>Best Drivers</div>
                    </div>
                    <div className="highlight-color cursor-pointer">Show All</div>
                </div>
                <div className=""><DriverCards driverType={driverType}/></div>
            </div>


            {/*..... overall summary .....*/}
            <div className="margin-b-50 border-bottom padding-b-40"><OverallSummary/></div>

            {/*..... comparison sec ......*/}
            <div className="margin-b-50">
                <div className="highlight-color section-title flex hr-space-between margin-b-20">
                    <div className="">Critical Alert Videos</div>
                    <div className="cursor-pointer">Show All</div>
                </div>
                <VideoSec onVideoClick={handleShowVideoPlayer}/>
            </div>


            {/*..... comparison sec ......*/}
            <div className="comparison-chart-section flex hr-space-between align-top">
                <div className="comparison-sec">
                    <div className="sf-medium font-18 margin-b-30 highlight-color">Fleet Comparison</div>
                    <FleetComparison/>
                </div>
                <div className="compare-chart-sec">
                   <div className="flex hr-space-between margin-b-30">
                       <div className="sf-medium font-18 highlight-color">
                           Alert Distribution <span className="grey-color sf-light">(comparison to last month)</span>
                       </div>
                       {/* <div className="sf-medium flex gap-50">
                           <label className="flex gap-10 width-content">
                               <RadioButton defaultChecked={true} name={'chart'}/>
                               <div className="">Overall</div>
                           </label>
                           <label className="flex gap-10 width-content">
                               <RadioButton name={'chart'}/>
                               <div className="">Per Driver</div>
                           </label>
                       </div> */}
                   </div>
                    <div className="compare-chart"><DashCompareChart/></div>
                </div>
            </div>

        </div>
    )
}

export default Dashboard;
